import { postSilentFetch } from 'request/request';

export async function resendEmail() {
  await postSilentFetch('/users/profile/resend-verification-email', {});
}
